// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_cf-2";
export var aiChatCartContainerExit = "_cf-4";
export var aiChatContainerLarge = "_cf-0";
export var aiChatContainerSmall = "_cf-1";
export var aiChatIcon = "_cf-6";
export var slideInFromRight = "_cf-3";
export var slideOutToRight = "_cf-5";